module.exports = __webpack_public_path__ + "img/1440.153dc5fb.jpg";